import React from 'react';
import { ButtonOptionSystemStyle } from './style';

export default function ButtonOptionSystem({ systemName, border, active, setSystemOption, width }) {
  return (
    <ButtonOptionSystemStyle width={width} border={border} active={active} onClick={() => setSystemOption(systemName)}>
      {systemName}
    </ButtonOptionSystemStyle>
  );
}
